import { createContext } from "react";

interface ModalContextType {
	openModal: (modalName: string, props?: Record<string, unknown>) => void;
	closeModal: () => void;
	closeAllModals: () => void;
}

export const ModalContext = createContext<ModalContextType | null>(null);
